import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      q: "What age group is Practido Learning Center designed for?",
      a: "Practido offers programs for students aged 6 to 18 years with age-appropriate learning pathways and projects."
    },
    {
      q: "Do students need prior coding experience?",
      a: "No. Most beginner programs require no prior coding or robotics knowledge. We start from the very basics."
    },
    {
      q: "What will students learn at Practido?",
      a: "Students learn Artificial Intelligence, Robotics, Coding, STEM, Design Thinking, Video Editing, Creativity and Future Skills through hands-on projects."
    },
    {
      q: "Are classes available online and offline?",
      a: "Yes. Students can join online classes, offline center programs or hybrid learning options depending on their location."
    },
    {
      q: "Will students build real projects?",
      a: "Yes. Every program includes practical projects that help students apply concepts and build confidence."
    },
    {
      q: "Do students receive certificates?",
      a: "Yes. Students receive certificates after completing courses and projects. Advanced students also earn competition certificates."
    },
    {
      q: "How do AI and robotics classes help children?",
      a: "These programs develop creativity, logical thinking, problem-solving, collaboration and technology skills that are valuable across all future careers."
    },
    {
      q: "Can a 6-year-old learn coding?",
      a: "Yes. Young learners start with Scratch — a visual tool that teaches logic and creativity through games and animations, with no typing required."
    },
    {
      q: "How do I enroll my child?",
      a: "Book a free demo class from this page. Our team will understand your child's level and suggest the right course and plan. No payment needed for the demo."
    }
  ];

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return (
    <section className="section faq section-white" id="faq">
      <div className="container">
        <div className="section-header reveal-triggered fade-up active">
          <h2 style={{ color: "var(--text-primary)", fontWeight: 800 }}>Frequently Asked <span className="text-gradient">Questions</span></h2>
          <p>Everything you need to know about Practido Learning Center.</p>
        </div>

        <div className="faq-container reveal-triggered fade-up delay-100 active">
          {faqs.map((faq, index) => {
            const isActive = activeIndex === index;
            return (
              <div key={index} className={`faq-item ${isActive ? "active" : ""}`}>
                <button className="faq-question" onClick={() => handleToggle(index)}>
                  {faq.q}
                  <ChevronDown style={{ color: "#FF8E1F", transform: isActive ? "rotate(180deg)" : "none", transition: "transform 0.4s ease" }} />
                </button>
                <div className="faq-answer" style={{ maxHeight: isActive ? "200px" : "0px", overflow: "hidden", transition: "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)" }}>
                  <p>{faq.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
